import { Component, Inject, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-modal-asignar",
  templateUrl: "./modal.component.html",
})
export class MantenimientoResumenModal  {
  public form: FormGroup;
  llimite: string;
  public fileList: File[] = [];
  public imagesList: any[] = [];
  constructor(
    public dialogRef: MatDialogRef<MantenimientoResumenModal>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

}
